import { render, staticRenderFns } from "./ConfigTabInheritance.vue?vue&type=template&id=6acdb6a2"
import script from "./ConfigTabInheritance.vue?vue&type=script&lang=js"
export * from "./ConfigTabInheritance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports